module.exports = __webpack_public_path__ + "static/media/logo-caprabo.48e54159.svg";